import React, { useState, useEffect, useContext } from "react";
import { styled } from "@mui/system";
import {
  Typography,

  Snackbar,
  useTheme,
  Box,

  Card,
  CardContent,
  Button,
  LinearProgress,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import Alert from "@mui/material/Alert";
import StyleGuides from "../style-guides";
import ClipboardJS from "clipboard";
import _ from "lodash";
import Countdown from 'react-countdown';
import { AppVarsContext } from "../../context/AppVarsContext";
import { CopyAll } from "@mui/icons-material";

const idFromUrl = window.location.href.substring(
  window.location.href.lastIndexOf("/") + 1
);

const v = decodeURIComponent(atob(idFromUrl))
const id = decodeURI(v.toString("ascii").split("|")[0]);

// Styled Components
const Root = styled("div")(({ theme }) => ({
  backgroundColor: "ghostwhite",
  textAlign: 'center',
  padding: theme.spacing(1),
  height: "100vh",
  ".hide-preview": {
    textAlign: "center",
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  minWidth: 275,
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
}));


const ScriptContainer = styled(Box)(({ theme }) => ({
  background: "#272822",
  wordBreak: "break-all",
  whiteSpace: "pre-wrap",
  color: "#fff",
  padding: theme.spacing(2),
  fontSize: "1rem",
  borderRadius: 4,
  width: '50%'
}));




const Completionist = (props) => <Box borderRadius={1} border="1px solid #cfcfcf" p={2} mb={3} textAlign="center" bgcolor="#f7f7f7" ><Typography variant="body2">{props.msg}</Typography></Box>;

// Renderer callback with condition
const rendererTimerStart = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist msg={'The lightbox has started!'} />;
  } else {
    // Render a countdown
    return <Box display="flex" mt={1} mb={3} ><Box borderRadius={1} border="1px solid #cfcfcf" textAlign="center" bgcolor="#f7f7f7" width="25%" mr={1} p={1}>{(days > 0 ? days : 0)}<br></br>Day(s)</Box><Box bgcolor="#f7f7f7" textAlign="center" width="25%" borderRadius={1} border="1px solid #cfcfcf" mr={1} p={1}>{(hours > 0 ? hours : 0)} <br></br>hour(s)</Box><Box bgcolor="#f7f7f7" textAlign="center" width="25%" borderRadius={1} border="1px solid #cfcfcf" mr={1} p={1}>{(minutes > 0 ? minutes : 0)}<br></br>minute(s)</Box><Box bgcolor="#f7f7f7" width="25%" textAlign="center" borderRadius={1} border="1px solid #cfcfcf" p={1}>{(seconds > 0 ? seconds : '')}<br></br>second(s)</Box></Box>;
  }
};


// Renderer callback with condition
const rendererTimerEnd = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist msg={'The lightbox has ended!'} />;
  } else {
    // Render a countdown
    return <Box display="flex" mt={1} mb={3}  ><Box borderRadius={1} border="1px solid #cfcfcf" textAlign="center" bgcolor="#f7f7f7" width="25%" mr={1} p={1}>{(days > 0 ? days : 0)}<br></br>Day(s)</Box><Box borderRadius={1} border="1px solid #cfcfcf" bgcolor="#f7f7f7" textAlign="center" width="25%" mr={1} p={1}>{(hours > 0 ? hours : 0)} <br></br>hour(s)</Box><Box borderRadius={1} border="1px solid #cfcfcf" bgcolor="#f7f7f7" textAlign="center" width="25%" mr={1} p={1}>{(minutes > 0 ? minutes : 0)}<br></br>minute(s)</Box><Box borderRadius={1} border="1px solid #cfcfcf" bgcolor="#f7f7f7" width="25%" textAlign="center" p={1}>{(seconds > 0 ? seconds : '')}<br></br>second(s)</Box></Box>;
  }
};

function formatDateToMMDDYYYYHHMMSS(dateString) {
  const date = new Date(dateString); // Parse the date string
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const yyyy = date.getUTCFullYear();
  const HH = String(date.getUTCHours()).padStart(2, '0');
  const MM = String(date.getUTCMinutes()).padStart(2, '0');
  const SS = String(date.getUTCSeconds()).padStart(2, '0');

  return `${mm}/${dd}/${yyyy} ${HH}:${MM}:${SS}`;
}



const LightboxPreview = (props) => {

  const { appVars } = useContext(AppVarsContext);

  //console.log("AppVars", appVars);
  const [lightbox, setLightbox] = useState();
  const [errors, setErrors] = useState({ open: false, msg: "" });
  const [stats, setStats] = useState({ impressions: 0, clicked: 0, closed: 0 });
  const [copySuccessShow, setCopySuccessShow] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const theme = useTheme();



  const handleClose = () => {
    setErrors({ open: false, msg: "" });
    setCopySuccessShow(false);
  };

  async function fetchData(id) {
    var scriptName;

    try {
      const res = await fetch(`${appVars.api_url}/lightbox/${id}`);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const lightboxData = await res.json();
      setLightbox(lightboxData);
      switch (lightboxData.type) {
        case 1:
          scriptName = 'a-preview.js';
          break;
        case 2:
          scriptName = 'h-preview.js';
          break;
        default:
          scriptName = 'a-preview.js';
          break;
      }

      const script = document.createElement("script");
      script.src = `${appVars.api_url}/scripts/${scriptName}`;
      script.async = true;
      script.id = `${id}|${lightboxData.beaconId}`;
      script.className = "dwi-components";

      document.body.appendChild(script);

      const a = formatDateToMMDDYYYYHHMMSS(new Date(lightboxData.startTime).toUTCString())
      const b = formatDateToMMDDYYYYHHMMSS(new Date(lightboxData.endTime).toUTCString())




      const statsData = {
        module: 'API',
        format: 'JSON',
        idSite: lightboxData.beaconId,
        period: 'range',
        date: `${new Date(a).getFullYear()}-${new Date(a).getMonth() + 1}-${new Date(a).getDate()},${new Date(b).getFullYear()}-${new Date(b).getMonth() + 1}-${new Date(b).getDate()}`,
        method: 'Events.getName',
        expanded: 1,
        pivotBy: 'Events.EventAction',
        pivotByColumnLimit: 20,
        pivotByColumn: 'nb_events',
        token_auth: appVars.matomo_token,
        filter_limit: 50
      };

      const statsResponse = await fetch(appVars.matomo_url + '/index.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(statsData).toString()
      });

      if (!statsResponse.ok) {
        throw new Error(`HTTP error! status: ${statsResponse.status}`);
      }

      const statsJson = await statsResponse.json();
      const targetStats = _.find(statsJson, (o) => o.label === lightboxData.lightboxId);

      if (targetStats) {
        setStats({
          label: statsJson[0].label,
          impressions: Object.values(targetStats)[1],
          closed: Object.values(targetStats)[2],
          clicked: Object.values(targetStats)[3],
        });
      }
    } catch (err) {
      setErrors({ open: true, msg: "Error fetching data" });
      console.error("Error:", err);
    }
  }

  useEffect(() => {

    if (appVars && id) {
      fetchData(id);
    }



    const clipboard = new ClipboardJS("#btn");
    clipboard.on("success", (e) => {
      setCopySuccess('Script has been copied to clipboard!');
      setCopySuccessShow(true);
      e.clearSelection();
    });

    return () => clipboard.destroy();
  }, [appVars, id]);

  return (
    (lightbox ?
      <Root>

        <Grid container spacing={3}>
          <Grid size={{ sm: 3 }} >
            <StyledCard>
              <Typography variant="h6" color="secondary">
                For Lightbox Preview Only.<br /> Close this window after Preview.
              </Typography>
              <Typography variant="body2" color="secondary">
                * Date/Display Settings ignored on this preview page.
              </Typography>
              <CardContent>
                {stats && (
                  <>
                    <Typography textAlign="left" variant="h6">
                      Stats
                    </Typography>
                    <Box display="flex" mb={3}  >


                      <Box width="50%" bgcolor="#f7f7f7" p={1} borderRadius={1} border="1px solid #cfcfcf" mr={1} >
                        <Typography align="center" color="info">
                          Impressions
                        </Typography>
                        <Typography align="center" color="info">
                          {stats.impressions}
                        </Typography>

                      </Box>

                      <Box width="50%" bgcolor="#f7f7f7" p={1} borderRadius={1} border="1px solid #cfcfcf" >
                        <Typography align="center" color="success">
                          Clicked
                        </Typography>
                        <Typography align="center" color="success">
                          {stats.clicked}
                        </Typography>

                      </Box>
                    </Box>

                  </>
                )}
                <Typography textAlign="left" variant="h6">
                  Starts
                </Typography>
                <Typography textAlign="left" variant="body2" gutterBottom color="textSecondary" component="p">
                  {formatDateToMMDDYYYYHHMMSS(new Date(lightbox.startTime).toUTCString())}
                </Typography>
                <Countdown date={lightbox.startTime} renderer={rendererTimerStart}>
                </Countdown>

                <Typography textAlign="left" variant="h6">
                  Ends
                  <Typography textAlign="left" variant="body2" color="textSecondary" component="p">
                    {formatDateToMMDDYYYYHHMMSS(new Date(lightbox.endTime).toUTCString())}
                  </Typography>
                </Typography>
                <Countdown date={lightbox.endTime} renderer={rendererTimerEnd}>
                </Countdown>
                <Box display="flex" mb={3}  >


                  <Box width="50%" bgcolor="#f7f7f7" p={1} borderRadius={1} border="1px solid #cfcfcf" mr={1} >
                    <Typography align="center" color="info">
                      Display Every
                    </Typography>
                    <Typography align="center" color="info">
                      {(lightbox.cookieExpire <= 0 ? 'Visit' : lightbox.cookieExpire + ' Day(s)')}
                    </Typography>

                  </Box>

                  <Box width="50%" bgcolor="#f7f7f7" p={1} borderRadius={1} border="1px solid #cfcfcf" >
                    <Typography align="center" color="info">
                      Delay
                    </Typography>
                    <Typography align="center" color="info">
                      {lightbox.delay / 1000} seconds
                    </Typography>

                  </Box>
                </Box>
              </CardContent>
            </StyledCard>


          </Grid>
          <Grid size={{ sm: 9 }} >

            <Box display="flex" gap={theme.spacing(2)} border="1px solid #272822" p={1} borderRadius={2} >
              <Box alignContent="center" mt={2} mb={2} p={1} pl={5} pr={5} width="50%" >
                <Typography textAlign="justify" gutterBottom variant='body2'>To activate the lightbox place the code in the <span style={{ color: 'red', fontWeight: 'bold' }}>&lt;head&gt;</span> tag of the pages you would like the lightbox to show. The lightbox is restricted by the setting 'restrictto' below in the script tag. This lightbox will only show on URLS containing the value of that setting. Remove for all unrestricted display.</Typography>
              </Box>
              <ScriptContainer alignContent="center" display="flex" gap={5}>

                <pre id="script-text" style={{ textAlign: 'left', background: '#272822', wordBreak: "break-all", whiteSpace: "initial", color: "#fff", fontSize: '1rem' }}>
                  &lt;script class="dwi-components" id="{lightbox.lightboxId + '|' + lightbox.beaconId}" src="https://api.digitalwerks.com/scripts/a.js"&gt;&lt;/script&gt;
                </pre>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  id="btn"
                  data-clipboard-target="#script-text"
                  startIcon={<CopyAll />}
                >Copy</Button>
              </ScriptContainer>
            </Box>


            <StyleGuides />
          </Grid>
        </Grid>
        <Snackbar style={{border:'1px solid #c7c7c7'}} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={copySuccessShow} autoHideDuration={1500} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            {copySuccess}
          </Alert>
        </Snackbar>
        <Snackbar open={errors.open} autoHideDuration={1500} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            {errors.msg}
          </Alert>
        </Snackbar>
      </Root>
      : <Box p={10} ><LinearProgress /></Box>)
  );
};

export default LightboxPreview;
